import React from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { useAppDispatch } from '../../../../support/store';
import { JourneyMapDraft } from '../../../../types/journeyMap';
import {
  addJourneyMapDraftPathGroup,
  updateJourneyMapDraftField,
} from '../../../../support/slices/journeyMapBuilderSlice';

type Props = {
  draft: JourneyMapDraft;
};

const JourneyMapSidePanelMapSettings: React.FC<Props> = ({ draft }) => {
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Journey Map
        </Typography>

        <TextField
          label="Name"
          size="small"
          value={draft.name}
          onChange={(e) =>
            dispatch(updateJourneyMapDraftField({ field: 'name', value: e.target.value }))
          }
          fullWidth
        />

        <TextField
          label="Description"
          size="small"
          value={draft.description || ''}
          onChange={(e) =>
            dispatch(updateJourneyMapDraftField({ field: 'description', value: e.target.value }))
          }
          multiline
          minRows={3}
          fullWidth
        />

        <Button
          variant="outlined"
          onClick={() => dispatch(addJourneyMapDraftPathGroup(undefined))}
        >
          Add Path Group
        </Button>
      </Stack>
    </Box>
  );
};

export default JourneyMapSidePanelMapSettings;